/* Enhancements for the swipeable photo strip on product cards.
   Markup: snippets/card-variant-carousel.liquid.

   3.56 REBUILD. The strip is now simply the product's first 4 photos — no
   colour grouping, no sibling-product fetching, no swatch-to-slide glide.
   That removed roughly two thirds of this file (fmtMoney / swatchFor /
   setPrice / injectSibling / groupRange / the swatch click handler all went).

   THE IMPORTANT PART — HYDRATION. Slides 2..4 ship a 1x1 transparent GIF and
   carry the real photo in data-srcset / data-sizes. hydrate() promotes those
   to real srcset / sizes on the FIRST interaction with that strip. touchstart,
   pointerdown and scroll all fire before (or at the very start of) the gesture
   that reveals photo 2, so the image is already in flight by the time it is on
   screen. A visitor who never swipes downloads one photo per card.

   Slides are real links, so tap/click still open the product with this file
   absent. This script adds:
   - html.cvc-touch / html.cvc-mouse so the CSS activates, and .cvc-card on the
     wrapper so the full-card-link pointer-events fix lands without :has();
   - hydration of slides 2..4 on first interaction;
   - pagination dots tracking the photo on screen;
   - mouse drag-to-scroll on desktop, snapping on release;
   - the click right after a swipe/drag is swallowed;
   - ?cvc=debug on-screen diagnostics.

   Delegated at document level, so View-more-injected cards are covered. */
(function () {
  if (window.__cvcInit) return;
  window.__cvcInit = true;

  var DEBUG = /[?&]cvc=debug/.test(location.search);
  var logEl = null;
  var buf = [];
  function dbg(m) {
    if (!DEBUG) return;
    buf.push(m);
    if (!logEl) {
      logEl = document.createElement('div');
      logEl.id = 'cvc-debug';
      logEl.style.cssText =
        'position:fixed;bottom:8px;left:8px;right:8px;z-index:2147483647;background:rgba(0,0,0,.85);color:#7CFC00;font:11px/1.45 monospace;padding:8px;border-radius:8px;max-height:45vh;overflow:auto;pointer-events:none;white-space:pre-wrap';
      (document.body || document.documentElement).appendChild(logEl);
    }
    logEl.textContent = buf.join('\n');
  }
  if (DEBUG) {
    window.addEventListener('error', function (e) {
      dbg('JS-ERR: ' + e.message + ' @' + String(e.filename).split('/').pop() + ':' + e.lineno);
    });
  }

  var coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  var touch =
    coarse ||
    'ontouchstart' in window ||
    (navigator.maxTouchPoints || 0) > 0 ||
    /[?&]cvc=(on|debug)/.test(location.search);
  document.documentElement.classList.add(touch ? 'cvc-touch' : 'cvc-mouse');
  dbg('activation: ' + (touch ? 'TOUCH' : 'MOUSE') + ' (coarse=' + coarse + ' maxTouchPoints=' + (navigator.maxTouchPoints || 0) + ')');

  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function slides(strip) {
    return Array.prototype.slice.call(strip.querySelectorAll('.cvc-slide'));
  }

  /* ---- Hydration ---------------------------------------------------------
     Swap data-srcset / data-sizes onto the real attributes so the browser
     starts fetching. Runs once per strip, on first interaction. */
  function hydrate(strip) {
    if (strip.__cvcHydrated) return;
    strip.__cvcHydrated = true;
    var n = 0;
    slides(strip).forEach(function (slide) {
      var im = slide.querySelector('img');
      if (!im) return;
      var ds = im.getAttribute('data-srcset');
      if (!ds) return;
      var dz = im.getAttribute('data-sizes');
      if (dz) {
        im.setAttribute('sizes', dz);
        im.removeAttribute('data-sizes');
      }
      im.setAttribute('srcset', ds);
      im.removeAttribute('data-srcset');
      im.setAttribute('loading', 'eager');
      n++;
    });
    if (n) dbg('hydrated ' + n + ' photo(s) on a strip');
  }

  function ensureDots(strip, ss, i) {
    var dots = strip.parentElement && strip.parentElement.querySelector('.cvc-dots');
    if (!dots) return;
    var count = ss.length;
    if (dots.getAttribute('data-cvc-sig') !== String(count)) {
      dots.setAttribute('data-cvc-sig', String(count));
      var html = '';
      for (var k = 0; k < count; k++) html += '<span></span>';
      dots.innerHTML = html;
    }
    var d = dots.children;
    for (var j = 0; j < d.length; j++) {
      if (j === i) d[j].classList.add('is-on');
      else d[j].classList.remove('is-on');
    }
  }

  function tagCards() {
    document.querySelectorAll('.cvc-strip').forEach(function (s) {
      var c = s.closest('.card-wrapper');
      if (c && !c.classList.contains('cvc-card')) c.classList.add('cvc-card');
      if (!s.__cvcDotsInit) {
        s.__cvcDotsInit = true;
        var ss0 = slides(s);
        if (ss0.length) ensureDots(s, ss0, 0);
      }
    });
  }

  function sync(strip) {
    var ss = slides(strip);
    if (!ss.length) return;
    var w = strip.clientWidth || 1;
    var i = Math.round(strip.scrollLeft / w);
    if (i < 0) i = 0;
    if (i > ss.length - 1) i = ss.length - 1;
    ensureDots(strip, ss, i);
  }

  function endGlide(strip, target) {
    if (strip.__cvcAnim) cancelAnimationFrame(strip.__cvcAnim);
    if (strip.__cvcTimer) clearTimeout(strip.__cvcTimer);
    strip.__cvcAnim = null;
    strip.__cvcTimer = null;
    strip.__cvcAnimating = false;
    strip.classList.remove('cvc-animating');
    if (typeof target === 'number') strip.scrollLeft = target;
    sync(strip);
  }

  /* Only used to settle the strip after a MOUSE DRAG is released — without it
     the strip would sit stranded between two photos. Nothing else animates. */
  function settleAfterDrag(strip, index) {
    var target = index * strip.clientWidth;
    if (REDUCED) {
      endGlide(strip, target);
      return;
    }
    endGlide(strip);
    var start = strip.scrollLeft;
    var delta = target - start;
    if (!delta) {
      sync(strip);
      return;
    }
    var dur = 220;
    var t0 = 0;
    strip.classList.add('cvc-animating');
    strip.__cvcAnimating = true;
    function frame(now) {
      if (!t0) t0 = now;
      var p = Math.min(1, (now - t0) / dur);
      var e = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p;
      strip.scrollLeft = start + delta * e;
      if (p < 1) strip.__cvcAnim = requestAnimationFrame(frame);
      else endGlide(strip, target);
    }
    strip.__cvcAnim = requestAnimationFrame(frame);
    strip.__cvcTimer = setTimeout(function () {
      endGlide(strip, target);
    }, dur + 150);
  }

  tagCards();
  if (window.MutationObserver) {
    new MutationObserver(tagCards).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('cvc-strip')) return;
      hydrate(t);
      if (!t.__cvcAnimating) t.setAttribute('data-cvc-last-scroll', String(Date.now()));
      if (!t.__cvcPending) {
        t.__cvcPending = true;
        setTimeout(function () {
          t.__cvcPending = false;
          sync(t);
        }, 90);
      }
      if (DEBUG && !t.__cvcLoggedScroll) {
        t.__cvcLoggedScroll = true;
        dbg('SWIPE WORKED - strip scrolled (x=' + Math.round(t.scrollLeft) + ')');
      }
    },
    true
  );

  document.addEventListener(
    'touchstart',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var strip = e.target.closest('.cvc-strip');
      if (!strip) return;
      hydrate(strip);
      if (strip.__cvcAnimating) endGlide(strip);
      if (DEBUG && !strip.__cvcLoggedTouch) {
        strip.__cvcLoggedTouch = true;
        dbg('touch reached the strip - overlay is NOT blocking');
      }
    },
    { passive: true }
  );

  /* ---- Desktop mouse drag-to-scroll -------------------------------------
     Native scroll-snap covers touch and trackpad; mouse users get click-drag.
     A move past a few px counts as a drag: it scrolls, settles on the nearest
     photo on release, and swallows the click so the photo does not navigate.
     A plain click (no drag) falls through to the slide link = opens product. */
  var dragStrip = null;
  var dragStartX = 0;
  var dragStartLeft = 0;
  var dragMoved = false;
  document.addEventListener(
    'pointerdown',
    function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (!e.target || !e.target.closest) return;
      var strip = e.target.closest('.cvc-strip');
      if (!strip) return;
      dragStrip = strip;
      dragStartX = e.clientX;
      dragStartLeft = strip.scrollLeft;
      dragMoved = false;
      hydrate(strip);
      if (strip.__cvcAnimating) endGlide(strip);
    },
    true
  );
  document.addEventListener(
    'pointermove',
    function (e) {
      if (!dragStrip) return;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) > 3) {
        dragMoved = true;
        dragStrip.classList.add('cvc-dragging');
      }
      if (dragMoved) {
        dragStrip.scrollLeft = dragStartLeft - dx;
        e.preventDefault();
      }
    },
    true
  );
  function endDrag() {
    if (!dragStrip) return;
    var strip = dragStrip;
    dragStrip = null;
    strip.classList.remove('cvc-dragging');
    if (dragMoved) {
      strip.setAttribute('data-cvc-last-scroll', String(Date.now()));
      var w = strip.clientWidth || 1;
      settleAfterDrag(strip, Math.round(strip.scrollLeft / w));
    }
  }
  document.addEventListener('pointerup', endDrag, true);
  document.addEventListener('pointercancel', endDrag, true);
  document.addEventListener(
    'dragstart',
    function (e) {
      if (e.target && e.target.closest && e.target.closest('.cvc-strip')) e.preventDefault();
    },
    true
  );

  /* Swallow the click that ends a swipe/drag so it does not open the product. */
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var strip = e.target.closest('.cvc-strip');
      if (!strip) return;
      var last = parseInt(strip.getAttribute('data-cvc-last-scroll') || '0', 10);
      if (Date.now() - last < 350) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  if (DEBUG) {
    var report = function () {
      var strips = document.querySelectorAll('.cvc-strip');
      dbg('strips on page: ' + strips.length + ' | :has(): ' + (window.CSS && CSS.supports && CSS.supports('selector(:has(*))')));
      var pending = document.querySelectorAll('.cvc-slide img[data-srcset]').length;
      dbg('un-hydrated photos still waiting: ' + pending + ' (should equal 3 x strips before any touch)');
      var s = strips[0];
      if (!s) return;
      var cs = getComputedStyle(s);
      dbg('first strip: display=' + cs.display + ' snap=' + (cs.scrollSnapType || '?') + ' z=' + cs.zIndex + ' cw=' + s.clientWidth + ' sw=' + s.scrollWidth + ' slides=' + s.querySelectorAll('.cvc-slide').length);
      var dz = s.parentElement && s.parentElement.querySelector('.cvc-dots');
      dbg('dots: ' + (dz ? dz.children.length + ' painted, display=' + getComputedStyle(dz).display : 'MISSING'));
      var r = s.getBoundingClientRect();
      if (r.width > 0 && r.bottom > 0 && r.top < window.innerHeight) {
        var hit = document.elementFromPoint(r.left + r.width / 2, Math.min(Math.max(r.top + r.height / 2, 1), window.innerHeight - 1));
        var ok = !!(hit && hit.closest && hit.closest('.cvc-strip'));
        dbg('HIT-TEST photo centre: <' + (hit ? hit.tagName.toLowerCase() : 'null') + '> reachesStrip=' + ok + (ok ? ' OK' : ' BLOCKED - if iframe, add &pb=0'));
      }
    };
    if (document.readyState === 'complete') setTimeout(report, 1200);
    else window.addEventListener('load', function () { setTimeout(report, 1200); });
  }
})();
